export let boolDialogCtrl = function ($scope, $modalInstance, $timeout) {
  $scope.close = function () {
    $modalInstance.close(false);
  };
  $scope.ok = function () {
    $modalInstance.close(true);
  };
};

/* ---------------------------------------------- */
/* helloDialogCtrl */

export let helloDialogCtrl = function ($scope, $modalInstance, $cookies) {
  $scope.close = function () {
    $cookies.put('notShowHello', $scope.notShowHello);
    $modalInstance.close();
  };
  $scope.change = function () {
    $scope.notShowHello = !$scope.notShowHello;
  };
};

export let configureAccountCtrl = function (
  $http,
  $scope,
  $modalInstance,
  accountCell,
  accountData,
) {

  $scope.accountCell = accountCell;
  $scope.accountData = accountData['data'];
  $scope.formErrors = accountData['errors'];

  $scope.ok = function () {
    if ($scope.accountData.email == '') {
      $scope.formErrors['email'] = [gettext('Введите емэйл!')];
      return;
    }

    $http.post(
      '/accounts/configacc/' + $scope.accountCell['agent_account.id'],
      $scope.accountData,
    )
      .then(function ({data}) {
        console.log('Saved profile: ' + data);
        if (!data['errors'] || data['errors'].length == 0) {
          $modalInstance.close(gettext('Пароль для ') + $scope.accountData['email'] + gettext(
              ' отправлен.'));
        }
        $scope.formErrors = data['errors'];
      })
      .catch(function ({data, status, headers, config}) {
        console.log(status, data);
      });

//     $modalInstance.close($scope.accountData);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };

};

/* ---------------------------------------------- */
/* showImageDialogCtrl */

export let updatesCtrl = function ($scope, $modalInstance, $http) {
  $scope.close = function () {
    $modalInstance.close();
  };
  $scope.ok = function (action) {
    $modalInstance.close(action);
  };
  $scope.fromData = function (data) {
    $scope.settings_server_version = data['settings_server_version'];
    $scope.settings_agent_version = data['settings_agent_version'];
    $scope.agent_update_required = data['agent_update_required'];
    $scope.message = data['message'];
  };
  $scope.init = function () {
    $scope.fromData({});
    $http.get('/analytics/update_agent/')
      .then(function ({data}) {
        $scope.fromData(data);
      })
      .catch(function ({data, status, headers, config}) {
        console.log(status, data);
      });
  };
  $scope.update_agent = function () {
    $http.post('/analytics/update_agent/')
      .then(function ({data}) {
        $scope.fromData(data);
      })
      .catch(function ({data, status, headers, config}) {
        console.log(status, data);
      });
  };
  $scope.init();
};

/* ---------------------------------------------- */
/* restartStaffcopDialogCtrl */
/*
export let restartStaffcopDialogCtrl = function (
  $scope,
  $modalInstance,
  $http,
  $timeout,
  $q,
) {
  $scope.close = function () {
    $modalInstance.close();
  };
  $scope.restarting = false;
  $scope.restartFailed = false;
  let send_restart_signal = function () {
    let deferred = $q.defer();
    $http.post('/analytics/restart_staffcop/')
      .then(function ({data}) {
        deferred.resolve('Staffcop restarted');
      })
      .catch(function ({data, headers, config}) {
        deferred.reject('Staffcop not restarted');
        $scope.restarting = false;
        $scope.restartFailed = true;
      });
    return deferred.promise;
  };
  let check_server = function (deferred) {
    $http.get('/analytics/restart_staffcop/')
      .then(function () {
        deferred.resolve('Staffcop is up');
      })
      .catch(function () {
        deferred.notify('Staffcop is not up');
      });
  };
  $scope.ok = function () {
    $scope.restarting = true;
    send_restart_signal()
      .then(
        function (result) {
          let deferred = $q.defer();
          check_server(deferred);
          deferred.promise.then(
            function (result) {
              window.location = '/';
            },
            function (result) {
              // console.log(result);
            },
            function (result) {
              if (result === 'Staffcop is not up') $timeout(function () {
                check_server(deferred);
              }, 1000);
            },
          );
        },
      )
      .catch((err) => {
        console.error(err);
      });
  };
};
*/

export let SaveTagCtrl = function ($scope, $modalInstance, $http, keyword) {

  let DEFAULT_CAT = gettext('Особое мнение');

  function getSelectionText() {
    let text = '';
    if (window.getSelection) {
      text = window.getSelection().toString();
    } else if (document.selection && document.selection.type != 'Control') {
      text = document.selection.createRange().text;
    }
    return text.trim();
  }

  $scope.loading = false;

  $scope.to = {
    tag      : keyword,
    regexp   : '',
    category : DEFAULT_CAT,
    type_name: 'text',
  };

  $scope.focusCategory = function () {
    if ($scope.to.category == DEFAULT_CAT) {
      $scope.to.category = '';
    }
  };

  $scope.blurCategory = function () {
    if ($scope.to.category == '') {
      $scope.to.category = DEFAULT_CAT;
    }
  };

  $scope.ok = function () {
    if ($scope.to.tag == '') {
      alert(gettext('Укажите текст'));
      return;
    }
    if ($scope.to.category == '') {
      alert(gettext('Укажите категорию'));
      return;
    }
    if ($scope.to.type_name == 'regexp') {
      if ($scope.to.regexp == '') {
        alert(gettext('Укажите регулярное выражение'));
        return;
      }
      try {
        let foo = RegExp($scope.to.regexp);
      }
      catch (e) {
        alert(gettext('Ошибка в регулярном выражении:') + '\n' + e.message);
        return;
      }
    }
    $scope.loading = true;
    $http.post('/analytics/tag/save/', $scope.to)
      .then(function () {
        $scope.loading = false;
        CACHE.reset();
        $modalInstance.close('ok');
      })
      .catch(() => {
        $scope.loading = false;
        alert(gettext('Ошибка сохранения'));
      });

  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };

};




// WEBPACK FOOTER //
// ./src/admin/modals.js